import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';

interface ChannelToggleProps {
    name: string;
    isMuted: boolean;
    onToggleMuteClick: () => void;
}

export const ChannelToggle = (props: ChannelToggleProps) => {
    if (props.isMuted) {
        return (
            <button id={"Mute" + props.name} className="btn btn-danger" onClick={(e: any) => { e.target.blur(); props.onToggleMuteClick() }} onKeyDown={OnIgnoreEnter}><i className="fas fa-volume-off fa-fw" aria-hidden="true"></i>&nbsp;{props.name}</button>
        );
    } else {
        return (
            <button id={"Mute" + props.name} className="btn btn-primary" onClick={(e: any) => { e.target.blur(); props.onToggleMuteClick() }} onKeyDown={OnIgnoreEnter}><i className="fas fa-volume-up fa-fw" aria-hidden="true"></i>&nbsp;{props.name}</button>
        );
    }
}
